import { FC, useState } from 'react'
import useFilter from '@components/Items/utils/hooks/useFilter'
import { QUERY_KEYS, splitActiveIds } from '@components/Items/utils/functions'
import _isEmpty from 'lodash/isEmpty'
import Checkbox from '@components/Items/components/checkbox'
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io'
import { sort } from 'fast-sort'
import Category2 from '@components/Items/Filters/Categories/Category2'

const Category1: FC<{ category1: string; category2List: string[] }> = ({
  category1,
  category2List,
}) => {
  const [label, category1Count] = category1.split('@@')
  const [isOpen, setIsOpen] = useState(false)
  const { categoryJsonQuery = {}, updateQuery } = useFilter()

  const category2QueryList = categoryJsonQuery[label] || []

  const { checked, unchecked } = splitActiveIds(
    category2QueryList,
    category2List.map((category2List) => category2List.split('@@')[0])
  )

  const isIndeterminate = Boolean(checked.length && unchecked.length)
  const isChecked = Boolean(unchecked.length ? false : checked.length)

  const handleChange = () => {
    if (isChecked) {
      delete categoryJsonQuery[label]
    } else {
      categoryJsonQuery[label] = category2List.map(
        (cat1) => cat1.split('@@')[0]
      )
    }

    updateQuery(
      QUERY_KEYS.CATEGORIES,
      encodeURIComponent(
        !_isEmpty(categoryJsonQuery) ? JSON.stringify(categoryJsonQuery) : ''
      )
    )
  }

  return (
    <div className="border-b border-gray-300 last:border-b-0">
      <Checkbox
        onChange={handleChange}
        checked={isChecked}
        isIndeterminate={isChecked ? false : isIndeterminate}
      >
        <div className={'flex justify-between items-center w-full'}>
          <div className="w-full flex justify-between">
            <span>{convert(label)}</span>
            <span className="text-10 px-1 text-gray-700">
              ({Number(category1Count).toLocaleString('en-US')})
            </span>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              setIsOpen(!isOpen)
            }}
          >
            {isOpen ? <IoIosArrowDown /> : <IoIosArrowForward />}
          </button>
        </div>
      </Checkbox>
      {isOpen ? (
        <div className={'pl-6'}>
          {sort(category2List)
            .by([
              {
                asc: (category2) => (category2.includes('Other') ? 1 : -1),
              },
              {
                asc: (category2) => category2,
              },
            ])
            .map((cat2) => {
              const [category2Label, category2Count] = cat2.split('@@')
              return (
                <div
                  key={`category-2-${category2Label}`}
                  className="border-b border-gray-300 last:border-b-0"
                >
                  <Category2 category1={label} category2={category2Label}>
                    <div className="flex justify-between">
                      <span>{category2Label}</span>
                      <span className="text-10 text-gray-700 pl-1">
                        ({Number(category2Count).toLocaleString('en-US')})
                      </span>
                    </div>
                  </Category2>
                </div>
              )
            })}
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

const convert = (category: string) => {
  switch (category) {
    case 'Clothing, Shoes & Jewelry':
      return 'Clothing, Shoes, Luggage, & Accessories'
    case 'Musical Instruments':
      return 'Musical Instruments & Accessories'
    default:
      return category
  }
}

export default Category1
